<div class="comments-section">
  <h4>Comments</h4>

  <div class="comment-input-area">
    @if (imagePreviews.length > 0) {
      <div class="image-chips">
        @for (preview of imagePreviews; track $index) {
          <div class="image-chip">
            <img class="image-chip__thumbnail" [src]="preview" alt="Attachment preview" />
            <pdq-button
              class="image-chip__remove"
              icon="close"
              variant="ghost"
              size="small"
              (onClick)="removeImagePreview($index)">
            </pdq-button>
          </div>
        }
      </div>
    }

    <div
      #commentTextarea
      [attr.contenteditable]="contenteditable"
      class="comment-textarea"
      [mentionConfig]="{
        items: usersList,
        insertHtml: true,
        mentionSelect: insertSpanElement,
      }"
      (opened)="onMentionOpened()"
      (closed)="onMentionClosed()"
      (itemSelected)="onUserMentionSelected($event)"
      placeholder="Add a comment"
      [(contenteditableModel)]="commentText"
      (keydown)="onKeydown($event)"></div>

    <div class="comment-input-actions">
      <pdq-button icon="image" variant="ghost" size="small" (onClick)="triggerFileUpload()"> </pdq-button>
      <input
        #fileInput
        type="file"
        accept="image/png,image/jpeg,image/gif,image/webp"
        multiple
        class="hidden-file-input"
        (change)="onFileSelected($event)" />
      <pdq-button
        [label]="uploading ? 'Uploading...' : 'Add'"
        variant="dark"
        size="small"
        [disabled]="uploading || (!commentText?.trim()?.length && imagePreviews.length === 0)"
        (onClick)="addComment()">
      </pdq-button>
    </div>
  </div>

  @if (comments.length > 0) {
    <div class="comments-list">
      @for (comment of comments; track comment.id) {
        <div class="comment">
          <div class="comment__header">
            <div class="comment__author">
              <div class="comment__avatar">
                <span>{{ getInitial(comment.author) }}</span>
              </div>
              <span class="comment__email">{{ comment.author || 'team@pdq.team' }}</span>
            </div>
            <div class="comment__actions">
              <span class="comment__date">{{ formatDate(comment.createdAt) }}</span>
              @if (isOwnComment(comment)) {
                <pdq-button
                  pdqPopover
                  variant="ghost"
                  icon="dots_menu"
                  size="small"
                  [popoverTemplate]="commentMenu"
                  [forcePosition]="'bottom'"
                  [closeOnPopoverClick]="true"
                  [closeOnClickOutside]="true">
                </pdq-button>
                <ng-template #commentMenu>
                  <pdq-popover-container [loading]="false" [actionList]="true">
                    <pdq-option (onSelect)="startEditComment(comment)"> Edit </pdq-option>
                    <pdq-option (onSelect)="deleteComment(comment.id)"> Delete </pdq-option>
                  </pdq-popover-container>
                </ng-template>
              }
            </div>
          </div>
          @if (editingCommentId === comment.id) {
            <div class="comment__edit">
              <pdq-textarea [control]="editControl" [maxLength]="2000" (keydown)="onEditKeydown($event)">
              </pdq-textarea>
              <div class="comment__edit-actions">
                <pdq-button label="Cancel" variant="ghost" size="small" (onClick)="cancelEditComment()"></pdq-button>
                <pdq-button label="Save" variant="dark" size="small" (onClick)="saveEditComment()"></pdq-button>
              </div>
            </div>
          } @else if (comment.text) {
            <p class="comment__text">{{ comment.text }}</p>
          }
          @if (comment.imageUrls?.length) {
            <div class="comment__images">
              @for (url of comment.imageUrls; track $index) {
                <img class="comment__image" [src]="url" alt="Comment attachment" />
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
